module.exports = "./img/9bbac7fb2d1f59734b9ccd26d8e24c71.jpg";